export default __webpack_public_path__ + "static/media/hop.eac3b0c7.png";